import React, { useEffect, useState, useCallback, ReactElement } from 'react';
import style from './block.module.scss';
import { BlockWrapper, defineBlock, useChildrenBlocks, useEditor } from '@smartfire/js-block-engine';

type Anchor = { name: string; position: number; link: string };

function Block() {
    const { isEditing } = useEditor();
    const { Child, Children, children } = useChildrenBlocks();

    const [sticky, setSticky] = useState(false);
    const [activeAnchor, setActiveAnchor] = useState<Anchor | undefined>(undefined);
    const listener = useCallback(() => {
        const anchors =
            children?.map((child) => (child as ReactElement)?.props?.node?.block?.props?.link).filter((link) => link) ??
            [];
        anchors.forEach((element) => {
            const anchorName = element.replace('#', '');
            const anchor = document.getElementById(anchorName);
            if (anchor) {
                anchors.push({
                    name: anchorName,
                    position: anchor ? anchor.getBoundingClientRect().top : 999,
                    link: element,
                });
            }
        });
        let currentAnchor: Anchor | undefined = undefined;

        if (anchors.length > 0) {
            for (let anchor of anchors) {
                if (anchor.position <= 150) {
                    currentAnchor = anchor;
                }
            }
        }
        if (currentAnchor?.link !== activeAnchor?.link) {
            setActiveAnchor(currentAnchor);
        }

        let position = document.getElementById('barAnchor')?.getBoundingClientRect().top;
        if (position && position <= 80 && !sticky) {
            setSticky(true);
        } else if (position && position > 80 && sticky) {
            setSticky(false);
        }
    }, [activeAnchor, sticky, children]);

    useEffect(() => {
        //initial listner call to set the header bar
        if (!isEditing) {
            listener();
            window.addEventListener('scroll', listener);
            window.addEventListener('resize', listener);
            return () => {
                window.removeEventListener('scroll', listener);
                window.removeEventListener('resize', listener);
            };
        }
        return () => {};
    }, [listener, isEditing]);

    return (
        <BlockWrapper.Div id="block" className={sticky ? style.stickyBlock : style.block}>
            <div id="barAnchor" />
            <div className={style.content}>
                <ul id="navBarLinks" className={style.navLinks}>
                    {isEditing ? (
                        <Children
                            gutenbergEditorConfig={{
                                allowedBlocks: ['smartfire/sticky-bar---item'],
                            }}
                        />
                    ) : (
                        children?.map((_, index) => <Child key={index} index={index} activeAnchor={activeAnchor} />)
                    )}
                </ul>
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,

    setup: {
        title: 'Sticky bar',
        icon: 'editor-insertmore',
    },
});
